<img [src]="url()" [alt]="name()" aria-hidden="true" />
